// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f85a214e","239":"e86e39b9","453":"c13accfb","732":"19d313f6"}[chunkId] + ".chunk.js";
};